import { useState, useEffect } from "react";
import { rootUrl, userKey } from "../App";
import { addDataIntoCache, getCacheData } from "../Redux/cacheSlice";

export const useGameItems = (type) => {
    const [allGames, setAllGames] = useState(null);

    useEffect(() => {
        if (!type) return; // Ensure type is provided

        const fetchGameItems = async () => {
            const cacheExpirationThreshold = 6 * 60 * 60 * 1000; // 6 hours in milliseconds
            const cacheKey = `gameItemsCache_${type}`;
            const cacheUrl = `${rootUrl}/game/getGameListByType/${type}/`;

            // Retrieve user token from local storage
            let stringValue = localStorage.getItem(userKey);
            let userToken = JSON.parse(stringValue)?.value;
            let isUserLoggedIn = !!userToken; // Check if the user is logged in

            const requestOptions = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    ...(userToken && { "Authorization": `Token ${userToken}` }),
                },
            };

            // Check cache
            const cachedData = await getCacheData(cacheKey, cacheUrl);

            if (cachedData) {
                const cachedTime = new Date(cachedData.updateDate);
                const currentTime = new Date();
                const timeDifference = currentTime - cachedTime;

                const cachedUserStatus = cachedData.isUserLoggedIn; // Retrieve cached login status

                // If cache is valid and user state matches, use the cached data
                if (
                    timeDifference < cacheExpirationThreshold &&
                    cachedUserStatus === isUserLoggedIn
                ) {
                    setAllGames(cachedData.data);
                    return;
                }
            }

            // Fetch data from API if cache is invalid, expired, or user state has changed
            try {
                const response = await fetch(cacheUrl, requestOptions);
                if (!response.ok) throw response;

                const data = await response.json();
                if (data?.status === "ok") {
                    setAllGames(data?.data);

                    // Cache the new data with updated login status
                    addDataIntoCache(cacheKey, cacheUrl, {
                        data: data?.data,
                        updateDate: new Date(),
                        isUserLoggedIn, // Store current login status in the cache
                    });
                }
            } catch (error) {
                console.error("Error fetching game items:", error);
            }
        };

        fetchGameItems();
    }, [type]);

    return {
        allGames,
    };
};